import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {connect} from 'react-redux';

import BaAx          from 'app/actions/company-admin/bank-accounts';
import ToastAx       from 'app/actions/toast';
import CadminApi     from 'app/apis/company-admin';
import Stripe        from 'app/apis/stripe';
import Modal         from 'app/components/common/modal';
import StandardInput from 'app/components/common/standard-input';
import utils from 'app/helpers/utils';

const TOS_URL = 'https://stripe.com/legal/end-customer-ach-payments-authorization';

class ModalMigrateBankAccount extends React.PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      name: null,
      isUpdatePending: false,
      didUpdateError: false,
      isConfirmPending: false,
      didConfirmError: false,
    };

    this.onChangeName = this.onChangeName.bind(this);
    this.onClose = this.onClose.bind(this);
    this.onClickSubmit = this.onClickSubmit.bind(this);
  }

  get name() {
    if (this.state.name != null) return this.state.name;
    return this.props.bankAccount.accountHolderName || '';
  }

  get hasChangeName() {
    return this.props.bankAccount.accountHolderName !== this.name;
  }

  get isSaving() {
    return this.state.isUpdatePending || this.state.isConfirmPending;
  }

  get submitDisabled() {
    if (!this.name.trim()) return true;
    if (this.isSaving) return true;
    return false;
  }

  onChangeName(event) {
    const name = event.target.value;
    this.setState({name});
  }

  onClose() {
    this.props.onClose();
  }

  async update() {
    if (!this.hasChangeName) return;
    const {update, bankAccount} = this.props;

    this.setState({isUpdatePending: true, didUpdateError: false});
    try {
      await update(bankAccount.id, {accountHolderName: this.name});
      this.setState({isUpdatePending: false, name: null});
    } catch (error) {
      this.setState({isUpdatePending: false, didUpdateError: true});
      throw error;
    }
  }

  async confirm() {
    const {company, bankAccount, get, toastSuccess} = this.props;

    this.setState({isConfirmPending: true, didConfirmError: false});
    try {
      const {clientSecret} = await CadminApi.bankAccountsGetMigrationSetupIntent(company.id, bankAccount.id);
      await Stripe.confirmUsBankAccountSetup(clientSecret);
      await get(bankAccount.id);
      this.setState({isConfirmPending: false});
      toastSuccess('Bank account is now ready for use.');
      this.onClose();
    } catch (error) {
      this.setState({isConfirmPending: false, didConfirmError: true});
      throw error;
    }
  }

  async onClickSubmit() {
    await this.update();
    await this.confirm();
  }

  render() {
    if (!this.props.bankAccount?.requiresMigration) return null;
    return (
      <Modal className="bform" onClose={this.onClose}>
        <h1 className="bform-h1">Confirm Bank Account</h1>
        <p className="notice">In order to continue using this bank account, we need you to confirm the account holder name and verify acceptance of the terms below.</p>

        <h2 className="bform-h2">{this.props.bankAccount.accountLabel}</h2>

        <label className="bform-h3">Account holder name</label>
        <StandardInput value={this.name} onChange={this.onChangeName} name="name" label="Account holder name" />

        <label className="bform-h3">Terms</label>
        <p>By saving your bank account to Millie, you agree to authorize payment subject to the terms and conditions outlined <a href={TOS_URL} className="blue-pink-hover" target="_blank">here</a>.</p>

        <div className="bform-actions">
          <div />
          <button onClick={this.onClickSubmit} className="btn blue" disabled={this.submitDisabled}>{this.isSaving ? 'Confirming...' : 'Confirm'}</button>
        </div>
      </Modal>
    );
  }

}

ModalMigrateBankAccount.propTypes = {
  company: PropTypes.object.isRequired,
  bankAccount: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
};

ModalMigrateBankAccount.defaultProps = {};

const stateToProps = (state) => ({
});

const dispatchToProps = (dispatch) => ({
  update: (id, attrs) => dispatch(BaAx.update(id, attrs)),
  get: (id) => dispatch(BaAx.get(id)),
  toastSuccess: (msg) => dispatch(ToastAx.success(msg)),
});

export default connect(stateToProps, dispatchToProps)(ModalMigrateBankAccount);
